// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"rD-z","smallCardRow":"sD-z","largeCardRow":"tD-z","productSearchRow":"uD-z","curatedRow":"vD-z"};